export enum GlobalTab {
  Samples,
  Tests,
  Containers,
  Requests,
  Blends,
  Distillations,
  StationaryTests,
}